import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClienteAddComponent } from './cliente-add/cliente-add.component';
import { ClienteEditComponent } from './cliente-edit/cliente-edit.component';
import { ClienteListComponent } from './cliente-list/cliente-list.component';
import { VentaListComponent } from './venta-list/venta-list.component';
import { VentaAddComponent } from './venta-add/venta-add.component';
import { CajaListComponent } from './caja-list/caja-list.component';
import { CajaEditComponent } from './caja-edit/caja-edit.component';
import { CajaAddComponent } from './caja-add/caja-add.component';
import { CajeroAsignarAddComponent } from './cajero-asignar-add/cajero-asignar-add.component';
import { CajeroAsignarListComponent } from './cajero-asignar-list/cajero-asignar-list.component';
import { ComprobanteAddComponent } from './comprobante-add/comprobante-add.component';
import { ComprobanteEditComponent } from './comprobante-edit/comprobante-edit.component';
import { ComprobanteListComponent } from './comprobante-list/comprobante-list.component';
import { RetencionesListComponent } from './retenciones-list/retenciones-list.component';
import { RetencionesAddComponent } from './retenciones-add/retenciones-add.component';
import { ProformaListComponent } from './proforma-list/proforma-list.component';
import { GuiaremisionListComponent } from './guiaremision-list/guiaremision-list.component';
import { ProformaAddComponent } from './proforma-add/proforma-add.component';
import { GuiaremisionAddComponent } from './guiaremision-add/guiaremision-add.component';
import { NotaCreditoListComponent } from './nota-credito-list/nota-credito-list.component';
import { NotaCreditoAddComponent } from './nota-credito-add/nota-credito-add.component';
import { NotaDebitoListComponent } from './nota-debito-list/nota-debito-list.component';
import { NotaDebitoAddComponent } from './nota-debito-add/nota-debito-add.component';
import { PreciosListComponent } from './precios-list/precios-list.component';
import { PreciosEditComponent } from './precios-edit/precios-edit.component';
import { PuntoVentaAddComponent } from './punto-venta-add/punto-venta-add.component';
import { PuntoVentaListComponent } from './punto-venta-list/punto-venta-list.component';
import { PuntoVentaTactilAddComponent } from './punto-venta-tactil-add/punto-venta-tactil-add.component';
import { PlanAcumulativoListComponent } from './plan-acumulativo-list/plan-acumulativo-list.component';
import { PlanAcumulativoAddComponent } from './plan-acumulativo-add/plan-acumulativo-add.component';
import { TransportistaAddComponent } from './transportista-add/transportista-add.component';
import { TransportistaEditComponent } from './transportista-edit/transportista-edit.component';
import { TransportistaListComponent } from './transportista-list/transportista-list.component';
import { PlanAcumulativoEditComponent } from './plan-acumulativo-edit/plan-acumulativo-edit.component';

const routes: Routes = [
	{ path: 'clientes/crear', component: ClienteAddComponent },
	{ path: 'clientes-edit', component: ClienteEditComponent },
	{ path: 'clientes-list', component: ClienteListComponent },
	{ path: 'ventas-list', component: VentaListComponent },
	{ path: 'ventas/crear', component: VentaAddComponent },
	{ path: 'cajas-list', component: CajaListComponent },
	{ path: 'cajas-edit', component: CajaEditComponent },
	{ path: 'cajas/crear', component: CajaAddComponent },
	{ path: 'asignar-cajero/crear', component: CajeroAsignarAddComponent },
	{ path: 'asignar-cajero-list', component: CajeroAsignarListComponent },
	{ path: 'comprobantes/crear', component: ComprobanteAddComponent },
	{ path: 'comprobantes-edit', component: ComprobanteEditComponent },
	{ path: 'comprobantes-list', component: ComprobanteListComponent },
	{ path: 'retenciones-list', component: RetencionesListComponent },
	{ path: 'retenciones/crear', component: RetencionesAddComponent },
	{ path: 'proformas-list', component: ProformaListComponent },
	{ path: 'proformas/crear', component: ProformaAddComponent },
	{ path: 'guiaremision-list', component: GuiaremisionListComponent },
	{ path: 'guiaremision/crear', component: GuiaremisionAddComponent },
	{ path: 'notacredito-list', component: NotaCreditoListComponent },
	{ path: 'notacredito/crear', component: NotaCreditoAddComponent },
	{ path: 'notadebito-list', component: NotaDebitoListComponent },
	{ path: 'notadebito/crear', component: NotaDebitoAddComponent },
	{ path: 'precios-list', component: PreciosListComponent },
	{ path: 'precios-edit', component: PreciosEditComponent },
	{ path: 'pos-edit', component: PuntoVentaAddComponent },
	{ path: 'pos-list', component: PuntoVentaListComponent },
	{ path: 'pos-tactil', component: PuntoVentaTactilAddComponent },
	{ path: 'planacumulativo-list', component: PlanAcumulativoListComponent },
	{ path: 'planacumulativo/crear', component: PlanAcumulativoAddComponent },
	{ path: 'planacumulativo/edit', component: PlanAcumulativoEditComponent },
	{ path: 'transportista/crear', component: TransportistaAddComponent },
	{ path: 'transportista-edit', component: TransportistaEditComponent },
	{ path: 'transportista-list', component: TransportistaListComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VentasRoutingModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/ventas-routing.module.ts